export default __webpack_public_path__ + "static/media/women-1.5480fa7c.jpg";